import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AuthGate } from './auth/AuthGate';
import { DashboardPage } from './pages/DashboardPage';
import { ControlsPage } from './pages/ControlsPage';
import { ControlDetailPage } from './pages/ControlDetailPage';
import { CyFunReportPage } from './pages/CyFunReportPage';
import { ComplianceManagerPage } from './pages/ComplianceManagerPage';
import { AzureControlsPage } from './pages/AzureControlsPage';
import { AzureDiagramPage } from './pages/AzureDiagramPage';
import { AzureControlDetailPage } from './pages/AzureControlDetailPage';
import { ScansPage } from './pages/ScansPage';
import { ScanDetailPage } from './pages/ScanDetailPage';
import { ReportsPage } from './pages/ReportsPage';
import { AutoDocPage } from './pages/AutoDocPage';
import { TenantsPage } from './pages/TenantsPage';
import { BillingPage } from './pages/BillingPage';
import { AlertsPage } from './pages/AlertsPage';
import { ScanSchedulePage } from './pages/ScanSchedulePage';
import { ManualChecksPage } from './pages/ManualChecksPage';
import { SupportPage } from './pages/SupportPage';
import { DevModePage } from './pages/DevModePage';
import { PartnersPage } from './pages/PartnersPage';
import { UsersPage } from './pages/UsersPage';
import { SettingsPage } from './pages/SettingsPage';
import { LoginPage } from './pages/LoginPage';
import { VerifyPage } from './pages/VerifyPage';
import { AcceptInvitationPage } from './pages/AcceptInvitationPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { OnboardingPage } from './pages/OnboardingPage';
// LicensePage import retire 2026.06 : page fusionnee dans BillingPage (cadre 1).
// /license redirige vers /billing via <Navigate>.
import { LicenseGate } from './auth/LicenseGate';
import { LicenseGuard } from './auth/LicenseGuard';

/**
 * 2 zones de routing :
 *  - Routes "publiques" : /login, /auth/verify - pas de Layout (page brandee plein ecran)
 *  - Routes "app"       : wrappees dans AuthGate + Layout
 */
export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login"                      element={<LoginPage />} />
      <Route path="/auth/verify"                element={<VerifyPage />} />
      <Route path="/auth/accept-invitation"     element={<AcceptInvitationPage />} />
      <Route path="/auth/reset-password"        element={<ResetPasswordPage />} />

      {/* App protegee */}
      <Route
        path="/*"
        element={
          <AuthGate>
            <LicenseGate>
              <Layout>
                <Routes>
                  <Route path="/"                  element={<DashboardPage />} />
                  <Route path="/controls"          element={<ControlsPage />} />
                  <Route path="/controls/:id"      element={<ControlDetailPage />} />
                  <Route path="/cyfun" element={<LicenseGuard featureNameKey="nav.cyfun"><CyFunReportPage /></LicenseGuard>} />
                  <Route path="/compliance" element={<LicenseGuard featureNameKey="nav.compliance"><ComplianceManagerPage /></LicenseGuard>} />
                  <Route path="/azure" element={<LicenseGuard featureNameKey="nav.azure"><AzureControlsPage /></LicenseGuard>} />
                  {/* Segment litteral : prioritaire sur /azure/:id (classement React Router v6). */}
                  <Route path="/azure/schema" element={<LicenseGuard featureNameKey="nav.azure"><AzureDiagramPage /></LicenseGuard>} />
                  <Route path="/azure/:id" element={<LicenseGuard featureNameKey="nav.azure"><AzureControlDetailPage /></LicenseGuard>} />
                  <Route path="/scans" element={<LicenseGuard featureNameKey="nav.scans"><ScansPage /></LicenseGuard>} />
                  <Route path="/scans/:scanId" element={<LicenseGuard featureNameKey="nav.scans"><ScanDetailPage /></LicenseGuard>} />
                  <Route path="/reports" element={<LicenseGuard requires="license" featureNameKey="nav.reports"><ReportsPage /></LicenseGuard>} />
                  <Route path="/autodoc" element={<LicenseGuard requires="license" featureNameKey="nav.autodoc"><AutoDocPage /></LicenseGuard>} />
                  <Route path="/tenants" element={<LicenseGuard requires="license" featureNameKey="nav.tenants"><TenantsPage /></LicenseGuard>} />
                  <Route path="/billing"           element={<BillingPage />} />
                  <Route path="/alerts" element={<LicenseGuard requires="business" featureNameKey="nav.alerts"><AlertsPage /></LicenseGuard>} />
                  <Route path="/schedule" element={<LicenseGuard requires="pro" featureNameKey="nav.schedule"><ScanSchedulePage /></LicenseGuard>} />
                  <Route path="/manual-checks" element={<LicenseGuard featureNameKey="nav.manual"><ManualChecksPage /></LicenseGuard>} />
                  <Route path="/support"           element={<SupportPage />} />
                  <Route path="/devmode"           element={<DevModePage />} />
                  <Route path="/partners"          element={<PartnersPage />} />
                  <Route path="/users" element={<LicenseGuard requires="pro" featureNameKey="nav.users"><UsersPage /></LicenseGuard>} />
                  <Route path="/settings"          element={<SettingsPage />} />
                  <Route path="/onboarding"        element={<OnboardingPage />} />
                  {/* /license redirige vers /billing depuis 2026.06 - les 2 pages
                      sont fusionnees en une seule (cadre 1 = Licence, cadre 2 = Abonnement). */}
                  <Route path="/license"           element={<Navigate to="/billing" replace />} />
                  <Route path="*"                   element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </LicenseGate>
          </AuthGate>
        }
      />
    </Routes>
  );
}
